import * as React from 'react';
import '../../global.js';
import { createComponent } from '@lit/react';
import { McToast as WebComponent } from '@maersk-global/mds-components-core-toast';

export const McToast = createComponent({
  react: React,
  tagName: 'mc-toast',
  elementClass: WebComponent,
  events: { close: 'close' },
});
